export const MEDICAL_INFORMATION = {
    grupoSanguineoId    : [0, { updateOn: 'change' }],    
    alergias            : [, { updateOn: 'change' }],
    enfermedades        : [, { updateOn: 'change' }],    
};